<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">道闸信息</span>
        <el-button type="primary" plain class="title-btn" @click="cancel">返回</el-button>
      </div>
      <SForm
        ref="firstForm"
        :fields="firstFormfields"
        :data-form="rowdata"
        label-width="150px"
        :is-show-btn="false"
        :inline="false"
        form-style="width: 400px;"
      />
    </el-card>
  </div>
</template>
<script>
import { HOST, EV_HOST } from '@/utils/host'
const token = window.localStorage.getItem('token')
export default {
  name: 'Daozhaxiangqing',
  components: {},
  data() {
    return {
      rowdata: {},
      firstFormfields: [
        {
          label: '道闸品牌',
          type: 'div',
          prop: 'name'
        },
        {
          label: '接入场站',
          type: 'div',
          prop: 'stationName'
        },
        {
          label: '车场ID',
          type: 'div',
          prop: 'carId'
        },
        {
          label: '应用ID',
          type: 'div',
          prop: 'appId'
        },
        {
          label: '验证码',
          type: 'div',
          prop: 'code'
        },
        {
          label: '订单推送地址',
          type: 'div',
          prop: 'url'
        },
        {
          label: '停车场名称',
          type: 'div',
          prop: 'portName'
        },
        {
          label: '修改人',
          type: 'div',
          prop: 'updater'
        },
        {
          label: '修改时间',
          type: 'div',
          prop: 'updateDate'
        }
      ]
    }
  },
  computed: {},
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    this.$store.dispatch('form/handle', {
      url: '/business/brake/getDataDetail',
      data: { id: this.$route.query.data },
      callback: resp => {
        if (resp) {
          this.rowdata = resp
        }
      }
    })
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    cancel() {
      this.$router.go(-1)
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
    .avatar-uploader /deep/ .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/views/systemManagement/gateDetail.vue